import { useState, useEffect, useRef } from 'react'
import { useForm, Controller } from 'react-hook-form'
import { useDispatch } from 'react-redux'
import { ArrowUpTrayIcon  } from '@heroicons/react/24/solid'
import { capitalize } from '@/utils/strings'
import { addFlashMessage } from '@/features/flash/flashMessagesSlice'

export default ({ 
  item,
  fileFieldName, 
  label = "", 
  disabled = false,
  inputProps = {},
  state = {
    errors: () => {},
    isUpdating: () => {},
    update: (data) => { /*formData to dispatch to update thunk */}
  }
}) => {
  const dispatch = useDispatch()
  // const errors = useSelector((state) => state.interventions.requestStatus.errors)
  // const isUpdating = useSelector((state) => state.interventions.loadingStatus.update)
  const errors = state.errors
  const isUpdating = state.isUpdating

  const isLoading = isUpdating
  const [isSubmitted, setIsSubmitted] = useState(false)
  const formRef = useRef(null)
  const fileInputRef = useRef(null)
  const formData = useRef({})

  const helperAcceptedFiles = () => {
    const acceptTypes = {
      'pdf': "seulement des fichiers PDF.",
      'image\/': "seulement des fichiers image.",
      'video\/': "seulement des fichiers vidéo.",
      'audio\/': "seulement des fichiers audio.",
      'text\/': "seulement des fichiers texte."
    }

    if (!inputProps.accept) {
      return ""
    }
                      
    for (const [pattern, message] of Object.entries(acceptTypes)) {
      if (inputProps.accept?.match && inputProps.accept?.match(pattern)) {
        return message
      }
    }
    
    return `Formats acceptés : ${inputProps.accept}`
  }

  const { handleSubmit, watch, reset,
    setValue, getValues,
    control, formState: { errors: formErrors }
  } = useForm({
    defaultValues: item,
    mode: 'onChange',
    reValidateMode: 'onChange'
  })

  /**
   * Récupère le message d'erreur pour un champ donné
   * Combine les erreurs de validation côté client et les erreurs API
   *
   * @param {string} fieldName - Nom du champ
   * @returns {string} Message d'erreur ou chaîne vide
   */
  const getErrorMessage = (fieldName) => {
    const errorsMsg = formErrors?.[fieldName]?.message || errors?.[fieldName] || ''
    if(Array.isArray(errorsMsg)) {
      return errorsMsg.join(", ")
    }
    return errorsMsg
  }

  // Effet pour détecter les changements dans l'état de chargement
  useEffect(() => {
    if (isSubmitted && !isUpdating) {
      if (!errors || Object.keys(errors).length === 0) {
        dispatch(addFlashMessage({
          type: 'success',
          text: `${capitalize(label)} a été téléversé avec succès.`
        }))
      } else {
        const accepts = helperAcceptedFiles()
        const msg = getErrorMessage(fileFieldName).length > 0 ? capitalize(getErrorMessage(fileFieldName)) : "Impossible de téléverser le fichier."
        dispatch(addFlashMessage({
          type: 'error',
          text: `${msg} ${accepts.length > 0 ? `: \r\n${accepts}` : "Essayer avec le formulaire de l'intervention."}`
        }))
      }

    }
  }, [isUpdating, errors])

  const handleFileChange = (e) => {
    const files = Array.from(e.target.files)
    if(formData && formData.current) {
      if(inputProps.multiple) {
        if (files.length > 0) {
          formData.current[fileFieldName] = files
        }
      } else {
        if (files[0]) {
          formData.current[fileFieldName] = files[0]
        }
      }
      onSubmit()
    }
  }

  /**
   * Gère la soumission du formulaire
   *
   * @param {Object} formData - Données du formulaire
   */
  const onSubmit = async () => {
    if(formData && formData.current) {
      try {
        setIsSubmitted(true)
        // await dispatch(updateIntervention({
        //   bien_id: intervention.bien_id, id: intervention.id, 
        //   data: formData.current
        // }))
        await dispatch(state.update(formData.current))
      } catch (error) {
        console.error(error)
        setIsSubmitted(false)
      }
    }
  }

  const handleUploadButtonClick = () => {
    setIsSubmitted(false)
    if(fileInputRef && fileInputRef.current) {
      fileInputRef.current.click()
    }
  }

  return (
    <div>
      { !isLoading && 
        <button 
          onClick={handleUploadButtonClick}
          className="btn btn-xs btn-ghost btn-square p-1 hover:bg-primary-400"
          title={`Téléverser ${label}`} aria-label={`Téléverser ${label}`}
          disabled={disabled}
        >
          <ArrowUpTrayIcon/>
        </button>
      }
      { isLoading && (
        <div className="flex items-center gap-2">
          <span className="loading loading-spinner"></span>
        </div>
      )}
      <form ref={formRef}>
        <Controller 
          name={fileFieldName}
          control={control}
          defaultValue=""
          rule={{}}
          render={({ field: { onChange, value, ref, ...field } }) => {
            return (
              <input
                type="file"
                className="hidden"
                ref={fileInputRef}
                {...field}
                {...inputProps} 
                onChange={handleFileChange}
                disabled={disabled}
              />
          )}}
        />
      </form>
    </div>
  )
}